import { useEffect, useRef } from "react";

import { createActiveDurationTracker } from "./activeDurationTracker";
import { logActivity } from "./activityLogger";

export const logInvestingActivity = (eventType, metadata = {}, options = {}) => {
  logActivity(eventType, metadata, { ...options, productArea: "investing" });
};

export const useInvestingActivityTimer = ({
  startEvent,
  endEvent,
  metadata = {},
  getEndMetadata,
  enabled = true,
  activityKey,
}) => {
  const metadataRef = useRef(metadata);
  const getEndMetadataRef = useRef(getEndMetadata);

  useEffect(() => {
    metadataRef.current = metadata;
    getEndMetadataRef.current = getEndMetadata;
  }, [metadata, getEndMetadata]);

  useEffect(() => {
    if (!enabled || !startEvent || !endEvent) return undefined;

    const wallStartedAt = Date.now();
    const tracker = createActiveDurationTracker();
    let ended = false;

    tracker.start(wallStartedAt);
    logInvestingActivity(startEvent, metadataRef.current);

    const end = (closeReason = "closed") => {
      if (ended) return;
      ended = true;
      const endedAt = Date.now();
      logInvestingActivity(
        endEvent,
        {
          ...metadataRef.current,
          ...(getEndMetadataRef.current?.() || {}),
          close_reason: closeReason,
          wall_duration_ms: Math.max(0, endedAt - wallStartedAt),
        },
        {
          durationMs: tracker.stop(endedAt),
          flushNow: true,
          preferBeacon: true,
        },
      );
    };

    const handlePageHide = () => end("page_hide");
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      window.removeEventListener("pagehide", handlePageHide);
      end("closed");
    };
  }, [enabled, startEvent, endEvent, activityKey]);
};
